(function () {
  'use strict';

  const WIDGET_ID = 'cart-upsell-inline-offer';
  const TIMER_KEY = 'sl_upsell_timer';
  const DONE_KEY  = 'sl_upsell_done';
  const ADDED_KEY = 'sl_upsell_added';

  let tickId = null;
  let isMutatingCart = false;
  let lastKnownCart = null;

  function fmt(ms) {
    const s = Math.max(0, Math.floor(ms / 1000));
    return String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
  }

  function getConfig() {
    return window.CartUpsellConfig || null;
  }

  function getOfferProductIds() {
    const cfg = getConfig();
    if (!cfg) return [];
    if (Array.isArray(cfg.productIds) && cfg.productIds.length > 0) {
      return cfg.productIds.map(String);
    }
    if (cfg.productId) return [String(cfg.productId)];
    return [];
  }

  function getUpsellOnlyProductIds() {
    const ids = new Set(getOfferProductIds());
    document.querySelectorAll('.cart-item--upsell-only[data-product-id]').forEach(function (row) {
      if (row.dataset.productId) ids.add(String(row.dataset.productId));
    });
    return Array.from(ids);
  }

  function lockCheckout() {
    const el = document.querySelector('cart-drawer');
    if (el) el.classList.add('upsell-checkout-locked');
  }

  function unlockCheckout() {
    const el = document.querySelector('cart-drawer');
    if (el) el.classList.remove('upsell-checkout-locked');
  }

  function cartHasOfferLines(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    const pids = getOfferProductIds();
    if (pids.length === 0) return false;
    return cart.items.some((it) => pids.indexOf(String(it.product_id)) !== -1);
  }

  function reconcileOfferSession(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    if (!cartHasOfferLines(cart)) {
      sessionStorage.removeItem(ADDED_KEY);
    }
  }

  function computeOfferTotals(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    const pids = getOfferProductIds();
    if (pids.length === 0) return null;
    const offerLines = cart.items.filter((it) => pids.indexOf(String(it.product_id)) !== -1);
    const offerTotal = offerLines.reduce(
      (sum, it) => sum + (it.line_price || it.original_line_price || 0),
      0
    );
    return {
      lines: offerLines,
      offerTotal,
      withoutOffer: (cart.total_price || 0) - offerTotal,
    };
  }

  function evaluateCheckoutLock(cart) {
    const cfg = getConfig();
    if (!cfg) { unlockCheckout(); return; }
    const totals = computeOfferTotals(cart);
    if (!totals || totals.lines.length === 0) { unlockCheckout(); return; }
    if (totals.withoutOffer < cfg.minCart) {
      lockCheckout();
    } else {
      unlockCheckout();
    }
  }

  function isReducingClick(target) {
    if (!target || !target.closest) return false;
    if (target.closest('cart-remove-button')) return true;
    const minus = target.closest('quantity-input button[name="minus"], button[name="minus"]');
    if (minus) return true;
    return false;
  }

  function progressGradient(pct, accent) {
    const color = accent || '#9f7247';
    const p = Math.min(100, Math.max(0, pct));
    return 'linear-gradient(90deg, ' + color + ' 0%, ' + color + ' ' + p + '%, #e5e1dc ' + p + '%, #e5e1dc 100%)';
  }

  function updateProgressBars() {
    // If the timed offer expired/was dismissed without being added, the offer
    // is "missed" — swap the celebratory tag for an apology. (DONE_KEY is only
    // set on expiry/dismiss, never on a successful add.)
    if (sessionStorage.getItem(DONE_KEY)) {
      document.querySelectorAll('.cart-upsell-progress__offer-tag').forEach(function (tag) {
        tag.textContent = '😔 Oops, you missed the exclusive offer!';
        tag.classList.add('cart-upsell-progress__offer-tag--missed');
      });
    }

    document.querySelectorAll('.cart-upsell-milestones[data-total]').forEach(function (bar) {
      const total    = parseInt(bar.dataset.total    || '0', 10);
      const offerMin = parseInt(bar.dataset.offerMin || '0', 10);
      const freeShip = parseInt(bar.dataset.freeShip || '1', 10);

      const fillPct  = freeShip > 0 ? Math.min(100, Math.max(0, (total / freeShip) * 100)) : 0;
      const offerPct = freeShip > 0 ? Math.min(100, Math.max(0, (offerMin / freeShip) * 100)) : 50;

      // Fill the bar left-to-right with an inline gradient (the bar is a normal
      // in-flow block, so it always has a real width).
      const barEl = bar.querySelector('.cart-upsell-milestones__bar');
      if (barEl) {
        const p = fillPct.toFixed(2);
        barEl.style.background =
          'linear-gradient(90deg, #9f7247 0%, #9f7247 ' + p + '%, #e6e3df ' + p + '%, #e6e3df 100%)';
      }

      // Offer node: position proportional to its threshold, toggle unlocked state
      const offerNode = bar.querySelector('.cart-upsell-milestones__node--offer');
      if (offerNode) {
        offerNode.style.left = offerPct.toFixed(2) + '%';
        const on = total >= offerMin;
        const c = offerNode.querySelector('.cart-upsell-milestones__circle');
        const l = offerNode.querySelector('.cart-upsell-milestones__node-label');
        if (c) c.classList.toggle('cart-upsell-milestones__circle--unlocked', on);
        if (l) l.classList.toggle('cart-upsell-milestones__node-label--unlocked', on);
      }

      // Ship node: pinned at 100%, toggle unlocked state
      const shipNode = bar.querySelector('.cart-upsell-milestones__node--ship');
      if (shipNode) {
        shipNode.style.left = '100%';
        const on = total >= freeShip;
        const c = shipNode.querySelector('.cart-upsell-milestones__circle');
        const l = shipNode.querySelector('.cart-upsell-milestones__node-label');
        if (c) c.classList.toggle('cart-upsell-milestones__circle--unlocked', on);
        if (l) l.classList.toggle('cart-upsell-milestones__node-label--unlocked', on);
      }
    });
  }

  function buildAddConfig() {
    const base = (typeof fetchConfig === 'function')
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' } };
    base.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete base.headers['Content-Type'];
    return base;
  }

  function getSectionsList() {
    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl && typeof cartDrawerEl.getSectionsToRender === 'function') {
      try {
        return cartDrawerEl.getSectionsToRender().map((s) => s.id);
      } catch (_) {
        // fall through
      }
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function dispatchCartChanged(cart) {
    if (cart) {
      document.dispatchEvent(
        new CustomEvent('cart:changed', { bubbles: false, detail: { cartobject: cart } })
      );
      return Promise.resolve(cart);
    }
    return fetch('/cart.js')
      .then((r) => r.json())
      .then((fresh) => {
        document.dispatchEvent(
          new CustomEvent('cart:changed', { bubbles: false, detail: { cartobject: fresh } })
        );
        return fresh;
      })
      .catch(() => null);
  }

  async function manualSectionRefresh(sections) {
    try {
      const url = window.location.pathname + '?sections=' + sections.join(',');
      const resp = await fetch(url);
      const data = await resp.json();
      const cartDrawerInner = document.getElementById('CartDrawer');
      if (cartDrawerInner && data['cart-drawer']) {
        const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        const fresh = doc.querySelector('#CartDrawer');
        if (fresh) cartDrawerInner.innerHTML = fresh.innerHTML;
      }
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data['cart-icon-bubble']) {
        const doc2 = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
        const section = doc2.querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      }
    } catch (err) {
      console.error('[CartUpsell] manual section refresh failed', err);
    }
  }

  function rerenderCart(data, cartDrawerEl) {
    if (!cartDrawerEl || !data || !data.sections) return false;
    try {
      cartDrawerEl.renderContents(data);
      return true;
    } catch (e) {
      console.error('[CartUpsell] renderContents threw, falling back', e);
      return false;
    }
  }

  async function enforceUpsellOnlyQuantities(cart) {
    if (isMutatingCart || !cart || !Array.isArray(cart.items)) return;

    const upsellOnlyIds = getUpsellOnlyProductIds();
    if (upsellOnlyIds.length === 0) return;

    const offenders = cart.items.filter(function (it) {
      return upsellOnlyIds.indexOf(String(it.product_id)) !== -1 && it.quantity > 1;
    });
    if (offenders.length === 0) return;

    isMutatingCart = true;
    const cartDrawerEl = document.querySelector('cart-drawer');
    const sectionsList = getSectionsList();

    try {
      let latestData = null;
      for (let i = 0; i < cart.items.length; i++) {
        const it = cart.items[i];
        if (upsellOnlyIds.indexOf(String(it.product_id)) === -1 || it.quantity <= 1) continue;

        const config = buildAddConfig();
        const formData = new FormData();
        formData.append('id', it.key);
        formData.append('quantity', '1');
        formData.append('sections', sectionsList.join(','));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        const resp = await fetch(window.routes.cart_change_url, config);
        latestData = await resp.json();
      }

      if (latestData) {
        lastKnownCart = latestData;
        const rerendered = rerenderCart(latestData, cartDrawerEl);
        if (!rerendered) {
          await manualSectionRefresh(sectionsList);
        }
        updateProgressBars();
        reconcileOfferSession(latestData);
        evaluateCheckoutLock(latestData);
        await dispatchCartChanged(latestData);
      }
    } catch (err) {
      console.error('[CartUpsell] enforce upsell-only qty failed', err);
    } finally {
      isMutatingCart = false;
    }
  }

  async function maybeAutoRemoveOffer(cart) {
    const cfg = getConfig();
    if (!cfg || getOfferProductIds().length === 0) return;
    if (isMutatingCart) return;
    if (!cart || !Array.isArray(cart.items)) return;

    const totals = computeOfferTotals(cart);
    if (!totals || totals.lines.length === 0) {
      unlockCheckout();
      return;
    }
    if (totals.withoutOffer >= cfg.minCart) {
      unlockCheckout();
      return;
    }

    lockCheckout();
    isMutatingCart = true;
    const cartDrawerEl = document.querySelector('cart-drawer');
    const sectionsList = getSectionsList();

    try {
      let latestData = null;
      for (const line of totals.lines) {
        const config = buildAddConfig();
        const formData = new FormData();
        formData.append('id', line.key);
        formData.append('quantity', '0');
        formData.append('sections', sectionsList.join(','));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        const resp = await fetch(window.routes.cart_change_url, config);
        latestData = await resp.json();
      }

      sessionStorage.removeItem(ADDED_KEY);

      if (latestData) {
        lastKnownCart = latestData;
        const rerendered = rerenderCart(latestData, cartDrawerEl);
        if (!rerendered) {
          await manualSectionRefresh(sectionsList);
        }
        updateProgressBars();
        evaluateCheckoutLock(latestData);
        await dispatchCartChanged(latestData);
      }
    } catch (err) {
      console.error('[CartUpsell] auto-remove offer failed', err);
    } finally {
      isMutatingCart = false;
      if (lastKnownCart) evaluateCheckoutLock(lastKnownCart);
    }
  }

  function initUpsell() {
    if (sessionStorage.getItem(DONE_KEY)) {
      if (tickId !== null) { clearInterval(tickId); tickId = null; }
      const dead = document.getElementById(WIDGET_ID);
      if (dead) dead.remove();
      updateProgressBars();
      return;
    }

    updateProgressBars();

    const widget = document.getElementById(WIDGET_ID);
    if (!widget) {
      if (tickId !== null) { clearInterval(tickId); tickId = null; }
      return;
    }

    if (widget._upsellInited) return;
    widget._upsellInited = true;

    if (tickId !== null) { clearInterval(tickId); tickId = null; }

    const durationMs = parseInt(widget.dataset.timer || '5', 10) * 60 * 1000;
    let start = parseInt(sessionStorage.getItem(TIMER_KEY) || '0', 10);
    if (!start) {
      start = Date.now();
      sessionStorage.setItem(TIMER_KEY, String(start));
    }

    const countdown = widget.querySelector('.cart-upsell-inline__countdown');

    function tick() {
      if (!document.getElementById(WIDGET_ID)) {
        clearInterval(tickId); tickId = null; return;
      }
      const remaining = durationMs - (Date.now() - start);
      if (remaining <= 0) {
        clearInterval(tickId); tickId = null;
        sessionStorage.setItem(DONE_KEY, '1');
        const w = document.getElementById(WIDGET_ID);
        if (w) w.remove();
        return;
      }
      if (countdown) {
        countdown.textContent = fmt(remaining);
        countdown.classList.toggle('cart-upsell-inline__countdown--urgent', remaining < 60000);
      }
    }

    tick();
    tickId = setInterval(tick, 1000);

    const atcBtn = widget.querySelector('.cart-upsell-inline__atc');
    if (atcBtn) {
      atcBtn.addEventListener('click', async function handleAtc(event) {
        event.preventDefault();
        if (atcBtn.getAttribute('aria-disabled') === 'true') return;

        const spinner = atcBtn.querySelector('.loading-overlay__spinner');
        const label   = atcBtn.querySelector('.cart-upsell-inline__atc-label');

        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.setAttribute('disabled', '');
        if (label)   label.textContent = 'Adding…';
        if (spinner) spinner.classList.remove('hidden');

        const variantId    = widget.dataset.variant;
        const cartDrawerEl = document.querySelector('cart-drawer');
        const sectionsList = getSectionsList();

        const config   = buildAddConfig();
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('sections', sectionsList.join(','));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        if (cartDrawerEl && typeof cartDrawerEl.setActiveElement === 'function') {
          cartDrawerEl.setActiveElement(document.activeElement);
        }

        isMutatingCart = true;
        let data = null;
        try {
          const resp = await fetch(window.routes.cart_add_url, config);
          data = await resp.json();
        } catch (err) {
          console.error('[CartUpsell] add request failed', err);
          atcBtn.removeAttribute('disabled');
          atcBtn.removeAttribute('aria-disabled');
          if (label)   label.textContent = 'Add';
          if (spinner) spinner.classList.add('hidden');
          isMutatingCart = false;
          return;
        }

        if (data && data.status) {
          console.warn('[CartUpsell] add returned error', data);
          atcBtn.removeAttribute('disabled');
          atcBtn.removeAttribute('aria-disabled');
          if (label)   label.textContent = 'Add';
          if (spinner) spinner.classList.add('hidden');
          isMutatingCart = false;
          return;
        }

        if (tickId !== null) { clearInterval(tickId); tickId = null; }
        sessionStorage.setItem(ADDED_KEY, '1');

        const rerendered = rerenderCart(data, cartDrawerEl);
        if (!rerendered) {
          await manualSectionRefresh(sectionsList);
        }

        updateProgressBars();
        await dispatchCartChanged();
        isMutatingCart = false;
      });
    }

    const dismissBtn = widget.querySelector('.cart-upsell-inline__dismiss');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        sessionStorage.setItem(DONE_KEY, '1');
        if (tickId !== null) { clearInterval(tickId); tickId = null; }
        widget.style.transition = 'opacity 0.2s ease, max-height 0.3s ease';
        widget.style.opacity    = '0';
        widget.style.maxHeight  = '0';
        widget.style.overflow   = 'hidden';
        setTimeout(() => widget.remove(), 300);
      });
    }
  }

  // ===== Auto-rolling announcement bar =====
  let annTimer = null;
  function initCartAnnouncement() {
    const bar = document.querySelector('.cart-announcement[data-interval]');
    if (!bar) {
      if (annTimer) { clearInterval(annTimer); annTimer = null; }
      return;
    }
    // Already initialised on this exact element — leave its loop running
    if (bar._annInited) return;
    bar._annInited = true;
    if (annTimer) { clearInterval(annTimer); annTimer = null; }

    const viewport = bar.querySelector('.cart-announcement__viewport');
    const track = bar.querySelector('.cart-announcement__track');
    if (!track || !viewport) return;

    const items = Array.prototype.slice.call(track.querySelectorAll('.cart-announcement__item'));
    if (items.length <= 1) return; // nothing to rotate

    const interval = Math.max(1500, parseInt(bar.dataset.interval || '3000', 10));
    const total = items.length;

    // Clone the first item and append it for a seamless wrap-around
    track.appendChild(items[0].cloneNode(true));

    let idx = 0;
    function step() {
      if (!document.body.contains(track)) { clearInterval(annTimer); annTimer = null; return; }
      const h = items[0].offsetHeight || viewport.offsetHeight;
      idx += 1;
      track.style.transition = 'transform 0.5s ease';
      track.style.transform = 'translateY(-' + (idx * h) + 'px)';
      if (idx >= total) {
        // We've animated onto the clone of the first item — snap back instantly
        window.setTimeout(function () {
          track.style.transition = 'none';
          idx = 0;
          track.style.transform = 'translateY(0)';
        }, 520);
      }
    }
    annTimer = setInterval(step, interval);
  }

  let reinitTimer = null;
  function scheduleInit() {
    clearTimeout(reinitTimer);
    reinitTimer = setTimeout(function () { initUpsell(); initCartAnnouncement(); }, 80);
  }

  function attachObserver() {
    const cartEl = document.getElementById('CartDrawer');
    if (!cartEl) return;
    new MutationObserver(scheduleInit).observe(cartEl, { childList: true, subtree: true });
  }

  function attachUpsellOnlyQtyGuard() {
    document.addEventListener(
      'click',
      function (event) {
        const target = event.target;
        if (!target || !target.closest) return;
        const plus = target.closest('.cart-item--upsell-only .quantity__button[name="plus"]');
        if (plus) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );
  }

  function onCartChanged(e) {
    const cart = e && e.detail && e.detail.cartobject;
    if (cart) {
      lastKnownCart = cart;
      reconcileOfferSession(cart);
      evaluateCheckoutLock(cart);
      enforceUpsellOnlyQuantities(cart).then(function () {
        maybeAutoRemoveOffer(lastKnownCart || cart);
      });
    }
    scheduleInit();
  }

  function attachPredictiveLock() {
    document.addEventListener(
      'click',
      function (event) {
        const target = event.target;
        if (!target || !target.closest) return;
        if (!target.closest('cart-drawer')) return;
        if (!isReducingClick(target)) return;
        if (cartHasOfferLines(lastKnownCart)) lockCheckout();
      },
      true
    );

    document.addEventListener(
      'change',
      function (event) {
        const target = event.target;
        if (!target || !target.matches) return;
        if (!target.matches('.quantity__input, input[name="updates[]"]')) return;
        if (!target.closest('cart-drawer')) return;
        if (cartHasOfferLines(lastKnownCart)) lockCheckout();
      },
      true
    );
  }

  function bootstrap() {
    initUpsell();
    initCartAnnouncement();
    attachObserver();
    attachPredictiveLock();
    attachUpsellOnlyQtyGuard();
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        lastKnownCart = cart;
        reconcileOfferSession(cart);
        evaluateCheckoutLock(cart);
        enforceUpsellOnlyQuantities(cart).then(function () {
          maybeAutoRemoveOffer(lastKnownCart || cart);
        });
      })
      .catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('cart:changed', onCartChanged);
})();